export enum Roles {
  ROLE_INSURER = 'ROLE_INSURER',
  ROLE_BROKER = 'ROLE_BROKER',
  ROLE_UNDERWRITER = 'ROLE_UNDERWRITER',
  ROLE_CORPORATE_ADMIN = 'ROLE_CORPORATE_ADMIN',
  ROLE_ADJUSTER = 'ROLE_ADJUSTER',
  ROLE_INSURANCE_AGENT = 'ROLE_INSURANCE_AGENT',
  ROLE_INSURANCE_ADVISOR = 'ROLE_INSURANCE_ADVISOR',
  ROLE_ADMIN = 'ROLE_ADMIN',
  ROLE_DIRECT_CORPORATE_ADMIN = 'ROLE_DIRECT_CORPORATE_ADMIN',
  ROLE_REPRESENTATIVE = 'ROLE_REPRESENTATIVE',
  ROLE_ASSOCIATION_ADMIN = 'ROLE_ASSOCIATION_ADMIN',
  ROLE_EXPERT = 'ROLE_EXPERT',
  ROLE_BOARD_MEMBER = 'ROLE_BOARD_MEMBER',
  ROLE_EARLY_BIRD = 'ROLE_EARLY_BIRD',
  ROLE_BUSINESS_ADMIN = "ROLE_BUSINESS_ADMIN"
}
